import type { Session } from '@openx/types/session';
import { loadInstanceName } from '../lib/oidc/oidcAuthInfo';
import { unpackAcl } from '../permission/unpackAcl';
import { isAdmin } from '../permission/validators';
import type { SessionQueryData } from './types';

export function deriveSessionState(session: Session): SessionQueryData {
  if (!session.user || !session.account || !session.acl_mapping) {
    return { details: session, instanceSlug: loadInstanceName() };
  }

  return {
    details: session,
    acl: {
      account: unpackAcl(session.account.compiled_acl),
      list: unpackAcl(session.compiled_acl || ''),
      mapping: session.acl_mapping,
      user: unpackAcl(session.user.compiled_acl),
    },
    isAdmin: isAdmin(session.user),
    instanceSlug: loadInstanceName(),
  };
}
